import { render, staticRenderFns } from "./TalentNav.vue?vue&type=template&id=05e51f38&scoped=true&"
import script from "./TalentNav.vue?vue&type=script&lang=js&"
export * from "./TalentNav.vue?vue&type=script&lang=js&"
import style0 from "./TalentNav.vue?vue&type=style&index=0&id=05e51f38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e51f38",
  null
  
)

export default component.exports